export const handleModalKeydown = (e, firstFocusableElement, lastFocusableElement, closeModal) => {
    if (e.key === "Escape" /* Key.Escape */) {
        closeModal();
    }
    else if (e.key === "Tab" /* Key.Tab */) {
        const current = e.currentTarget;
        if (current === firstFocusableElement && e.shiftKey) {
            e.preventDefault();
            lastFocusableElement.focus();
        }
        else if (current === lastFocusableElement && !e.shiftKey) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    }
};
export const isAppleDevice = () => {
    // 'ios' isn't standard, but third-party script providers like to mess with things they shouldn't
    const regex = /macintosh|iphone|ipad|ipod|ios/i;
    return regex.test(navigator.userAgent ?? "");
};
export const isMobile = () => {
    return window.innerWidth <= 991;
};
/**
 * True only while running under Vitest. Used to suppress import-time
 * self-instantiation of widgets so test files can import a module without
 * auto-constructing it. Reads `process` off `globalThis` rather than as a bare
 * identifier so the browser build (tsc/webpack) compiles without Node types;
 * in browser bundles `globalThis.process` is undefined and instantiation
 * always proceeds.
 */
export const isUnderTest = () => {
    const proc = globalThis.process;
    return proc?.env?.VITEST === "true";
};
export const selfInstantiateOnLoad = (Class) => {
    if (isUnderTest()) {
        return;
    }
    if (document.readyState === "loading") {
        window.addEventListener("DOMContentLoaded", () => new Class());
    }
    else {
        new Class();
    }
};
export const capitalize = (s) => {
    if (!s)
        return s;
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
};
